<script>
  export let name = '';
  export let channel = '';
  import { templates } from '../stores.js';
	import { navigate } from 'svelte-routing';

  import Header from '../components/Header.svelte';
  import EventCreateProcess from '../components/EventCreateProcess.svelte';

  const re = new RegExp(channel, 'i');
  const list = $templates.map(t => ({ name: t.name, id: t.id})).filter(t => t.name.match(re));
</script>

<style>
  .templates {
    margin: 4px;
  }
  .templates button {
    margin-bottom: 5px;
  }
</style>

<Header text="create event" />

<EventCreateProcess name={name} channel={channel}/>

<div class="container templates">
  <div>Select WildMoka template:</div>
  {#each list as {name: templateName, id}}
    <button class="button is-fullwidth is-primary" on:click={() => navigate(`/events/${name}/channels/${channel}/templates/${id}/${templateName}`)}>
      {templateName}
    </button>
  {/each}
</div>